import React from "react";

const ClientMovementRequestFormUI = ({ formData, setFormData, errors, readOnly = false }) => {
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handlePhoneChange = (e) => {
    const { name, value } = e.target;
    // Format Phone: XXXX-XXXXXXX
    const digits = value.replace(/\D/g, "").slice(0, 11);
    let formatted = digits;
    if (digits.length > 4) {
      formatted = `${digits.slice(0, 4)}-${digits.slice(4)}`;
    }
    setFormData((prev) => ({ ...prev, [name]: formatted }));
  };

  return (
    <div className="content p-4">
      <div className="row g-3">

        {/* Client Name */}
        <div className="col-md-6">
          <div className="form-floating form-floating-outline">
            <input
              type="text"
              className={`form-control ${errors?.client_name ? "is-invalid" : ""}`}
              name="client_name"
              value={formData.client_name || ""}
              onChange={handleChange}
              disabled={readOnly}
              placeholder="Client Name"
            />
            <label>Client Name <span className="text-danger">*</span></label>
            {errors?.client_name && <div className="invalid-feedback">{errors.client_name}</div>}
          </div>
        </div>

        {/* Date of Movement Request */}
        <div className="col-md-6">
          <div className="form-floating form-floating-outline">
            <input
              type="date"
              className={`form-control ${errors?.date_of_movement_request ? "is-invalid" : ""}`}
              name="date_of_movement_request"
              value={formData.date_of_movement_request || ""}
              onChange={handleChange}
              disabled={readOnly}
            />
            <label>Date of Movement Request <span className="text-danger">*</span></label>
            {errors?.date_of_movement_request && (
              <div className="invalid-feedback">{errors.date_of_movement_request}</div>
            )}
          </div>
        </div>

        {/* Purpose of Visit */}
        <div className="col-md-12">
          <div className="form-floating form-floating-outline">
            <textarea
              className={`form-control ${errors?.purpose_of_visit ? "is-invalid" : ""}`}
              name="purpose_of_visit"
              value={formData.purpose_of_visit || ""}
              onChange={handleChange}
              disabled={readOnly}
              placeholder="Purpose of Visit (Official work, Barber, Shopping, Family Outing, etc.….):"
              style={{ height: "80px" }}
            />
            <label>Purpose of Visit (Official work, Barber, Shopping, Family Outing, etc.….) <span className="text-danger">*</span></label>
            {errors?.purpose_of_visit && <div className="invalid-feedback">{errors.purpose_of_visit}</div>}
          </div>
        </div>

        {/* Requested Date */}
        <div className="col-md-4">
          <div className="form-floating form-floating-outline">
            <input
              type="date"
              className={`form-control ${errors?.requested_date ? "is-invalid" : ""}`}
              name="requested_date"
              value={formData.requested_date || ""}
              onChange={handleChange}
              disabled={readOnly}
            />
            <label>Requested Date <span className="text-danger">*</span></label>
            {errors?.requested_date && <div className="invalid-feedback">{errors.requested_date}</div>}
          </div>
        </div>

        {/* Requested Time */}
        <div className="col-md-4">
          <div className="form-floating form-floating-outline">
            <input
              type="time"
              className={`form-control ${errors?.requested_time ? "is-invalid" : ""}`}
              name="requested_time"
              value={formData.requested_time || ""}
              onChange={handleChange}
              disabled={readOnly}
            />
            <label>Requested Time <span className="text-danger">*</span></label>
            {errors?.requested_time && <div className="invalid-feedback">{errors.requested_time}</div>}
          </div>
        </div>

        {/* Estimated Duration */}
        <div className="col-md-4">
          <div className="form-floating form-floating-outline">
            <input
              type="text"
              className={`form-control ${errors?.estimated_duration ? "is-invalid" : ""}`}
              name="estimated_duration"
              value={formData.estimated_duration || ""}
              onChange={handleChange}
              disabled={readOnly}
              placeholder="Estimated Duration (in hours)"
            />
            <label>Estimated Duration (in hours) <span className="text-danger">*</span></label>
            {errors?.estimated_duration && <div className="invalid-feedback">{errors.estimated_duration}</div>}
          </div>
        </div>

        {/* Family Member Name */}
        <div className="col-md-4">
          <div className="form-floating form-floating-outline">
            <input
              type="text"
              className={`form-control ${errors?.family_member_name ? "is-invalid" : ""}`}
              name="family_member_name"
              value={formData.family_member_name || ""}
              onChange={handleChange}
              disabled={readOnly}
              placeholder="Family Member Name (Requesting)"
            />
            <label>Family Member Name (Requesting) <span className="text-danger">*</span></label>
            {errors?.family_member_name && <div className="invalid-feedback">{errors.family_member_name}</div>}
          </div>
        </div>

        {/* Relationship */}
        <div className="col-md-4">
          <div className="form-floating form-floating-outline">
            <input
              type="text"
              className={`form-control ${errors?.relationship ? "is-invalid" : ""}`}
              name="relationship"
              value={formData.relationship || ""}
              onChange={handleChange}
              disabled={readOnly}
              placeholder="Relationship with Client"
            />
            <label>Relationship with Client <span className="text-danger">*</span></label>
            {errors?.relationship && <div className="invalid-feedback">{errors.relationship}</div>}
          </div>
        </div>

        {/* Contact Number */}
        <div className="col-md-4">
          <div className="form-floating form-floating-outline">
            <input
              type="text"
              className={`form-control ${errors?.contact_number ? "is-invalid" : ""}`}
              name="contact_number"
              value={formData.contact_number || ""}
              onChange={handlePhoneChange}
              disabled={readOnly}
              placeholder="Contact Number"
            />
            <label>Contact Number <span className="text-danger">*</span></label>
            {errors?.contact_number && <div className="invalid-feedback">{errors.contact_number}</div>}
          </div>
        </div>

        {/* Agreement */}
        <div className="col-md-12 mt-4">
          <div className="card bg-light border-0">
            <div className="card-body">
              <h6 className="fw-bold mb-2">Agreement:</h6>
              <p className="small mb-3">I understand and agree that:</p>

              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="agreement_assigned"
                  name="agreement_assigned"
                  checked={!!formData.agreement_assigned}
                  onChange={handleChange}
                  disabled={readOnly}
                />
                <label className="form-check-label text-dark small" htmlFor="agreement_assigned">
                  Only off-duty nursing staff will be assigned.
                </label>
              </div>

              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="agreement_charges"
                  name="agreement_charges"
                  checked={!!formData.agreement_charges}
                  onChange={handleChange}
                  disabled={readOnly}
                />
                <label className="form-check-label text-dark small" htmlFor="agreement_charges">
                  Charges of PKR 1000/hour will apply.
                </label>
              </div>

              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="agreement_payment"
                  name="agreement_payment"
                  checked={!!formData.agreement_payment}
                  onChange={handleChange}
                  disabled={readOnly}
                />
                <label className="form-check-label text-dark small" htmlFor="agreement_payment">
                  Payment will be made after the visit at the reception.
                </label>
              </div>

              {errors?.agreement && (
                <div className="text-danger small mt-2">{errors.agreement}</div>
              )}
            </div>
          </div>
        </div>

        {/* Finance Information */}
        <div className="col-12 mt-4">
          <h6 className="fw-semibold text-primary border-bottom pb-2">
            <i className="ri-wallet-3-line me-1"></i> Finance Information
          </h6>
          <div className="row g-3">
            <div className="col-md-3">
              <div className="form-floating form-floating-outline mb-3">
                <input
                  type="text"
                  className="form-control"
                  name="amount"
                  value={formData.amount || ""}
                  onChange={handleChange}
                  placeholder="Amount"
                  disabled={readOnly}
                />
                <label>Amount</label>
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-floating form-floating-outline mb-3">
                <select
                  className="form-select"
                  name="payment_status"
                  value={formData.payment_status || ""}
                  onChange={handleChange}
                  disabled={readOnly}
                >
                  <option value="">Select Status</option>
                  <option value="Paid">Paid</option>
                  <option value="unpaid">Unpaid</option>
                </select>
                <label>Payment Status</label>
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-floating form-floating-outline mb-3">
                <input
                  type="text"
                  className="form-control"
                  name="reference_no"
                  value={formData.reference_no || ""}
                  onChange={handleChange}
                  placeholder="Reference No"
                  disabled={readOnly}
                />
                <label>Reference No</label>
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-floating form-floating-outline mb-3">
                <input
                  type="date"
                  className="form-control"
                  name="payment_date"
                  value={formData.payment_date ? formData.payment_date.substring(0, 10) : ""}
                  onChange={handleChange}
                  disabled={readOnly}
                />
                <label>Payment Date</label>
              </div>
            </div>
          </div>
        </div>

        {/* Signature */}
        <div className="col-md-12 mt-3">
          <div className="form-floating form-floating-outline">
            <input
              type="text"
              className={`form-control ${errors?.signature ? "is-invalid" : ""}`}
              name="signature"
              value={formData.signature || ""}
              onChange={handleChange}
              disabled={readOnly}
              placeholder="Signature (Typed name is acceptable for WhatsApp)"
            />
            <label>Signature (Typed name is acceptable for WhatsApp) <span className="text-danger">*</span></label>
            {errors?.signature && <div className="invalid-feedback">{errors.signature}</div>}
          </div>
        </div>

      </div>
    </div>
  );
};

export default ClientMovementRequestFormUI;
